import React from 'react';

interface ModuleEditorBaseProps {
  /** Accepted for API compatibility with existing editors. Not rendered. */
  moduleType?: string;
  moduleTitle?: string;
  onTitleChange?: (title: string) => void;
  onDelete?: () => void;
  isSaving?: boolean;
  isSaved?: boolean;
  embedded?: boolean;
  children: React.ReactNode;
}

/**
 * Transparent pass-through wrapper.
 *
 * Historically rendered a bordered card with a type badge, inline-editable
 * title, save indicator, and delete button. The current designs place the
 * content-name field, save/cancel actions, and delete control on the
 * surrounding overlay, so this wrapper now just renders its children.
 *
 * Props are kept on the interface so call sites don't need to change.
 */
export default function ModuleEditorBase({ children }: ModuleEditorBaseProps) {
  return <>{children}</>;
}
